// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"merge-cells"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M3 3L21 3L21 21L3 21L3 3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12 7V3M12 21V17M3 3V21H21V3H3Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M8.33008 13.768L10.0978 12.0002L8.33008 10.2324M15.768 10.2321L14.0002 11.9998L15.768 13.7676","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-merge-cells')
export default class MergeCellsIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'merge-cells',
    }
  }
}
